import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/admin.css';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setErrorMsg('Vui lòng nhập đầy đủ email và mật khẩu.');
      return;
    }

    setLoading(true);
    setErrorMsg('');

    try {
      const loggedUser = await login(email, password);
      // Admin vào giao diện quản trị như cũ; các role phòng ban vào thẳng dashboard.
      navigate(loggedUser.role === 'admin' ? '/admin/jobs' : '/admin/dashboard');
    } catch (err) {
      setErrorMsg(err.message || 'Đăng nhập không thành công.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc' }}>
      <div className="admin-login__card" style={{ maxWidth: '440px', width: '100%', padding: '40px 32px', background: '#fff', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <img src="/assets/img/logo-icon.svg" alt="Thế Thảo Pharma" width="56" height="56" style={{ margin: '0 auto 12px auto' }} />
          <span className="eyebrow">Quản trị nội bộ</span>
          <h1 style={{ fontSize: '1.6rem', marginTop: '4px' }}>Đăng nhập <span className="accent">Admin</span></h1>
          <p className="lead" style={{ fontSize: '0.9rem', color: '#64748b' }}>Hệ thống quản lý nội dung &amp; hồ sơ tuyển dụng Thế Thảo Pharma.</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-form">
          <label className="field">
            <span className="field__label">Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@thethaopharma.vn"
              required
            />
          </label>

          <label className="field">
            <span className="field__label">Mật khẩu</span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </label>

          {errorMsg && (
            <p className="form-alert is-error" style={{ color: '#b42318', fontSize: '0.85rem', margin: '8px 0' }}>
              {errorMsg}
            </p>
          )}

          <button
            className="btn btn--primary"
            type="submit"
            disabled={loading}
            style={{ width: '100%', justifyContent: 'center', marginTop: '16px' }}
          >
            <span className="btn-label">{loading ? 'Đang xác thực…' : 'Đăng nhập'}</span>
          </button>

          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <Link to="/" style={{ fontSize: '0.85rem', color: '#64748b' }}>
              ← Quay lại trang chủ website
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
